const normalize = value => String(value ?? '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l');
const attributeName = name => normalize(name.replace(/^attribute_/, '').replace(/^pa_/, ''));

export const matchesVariant = (variant, values) => Object.entries(values).every(([key, value]) => !value || !variant.attributes[key] || variant.attributes[key] === value);

/** Match actual options, including local attributes and global WooCommerce taxonomies. */
export const defaultAddonValues = (item, base, baseValues, current = {}) => {
    const preferred = {};
    item.attributes.forEach(attribute => {
        const source = base.attributes.find(candidate => attributeName(candidate.name) === attributeName(attribute.name))
            || base.attributes.find(candidate => normalize(candidate.label) === normalize(attribute.label));
        if (!source || !baseValues[source.name]) return;
        const value = baseValues[source.name];
        const selected = source.options.find(option => option.value === value);
        const option = attribute.options.find(option => option.value === value)
            || attribute.options.find(option => selected && normalize(option.label) === normalize(selected.label))
            || attribute.options.find(option => normalize(option.value) === normalize(value));
        if (option) preferred[attribute.name] = option.value;
    });

    const available = item.variants.filter(variant => variant.available);
    const matching = available.filter(variant => matchesVariant(variant, preferred));
    // If the requested combination is unavailable, retain a valid choice or the merchant's default.
    const candidates = matching.length ? matching : available;
    const complete = item.attributes.every(attribute => current[attribute.name]);
    const variant = candidates.find(variant => complete && matchesVariant(variant, current))
        || candidates.find(variant => matchesVariant(variant, item.defaults || {}))
        || candidates[0];
    if (!variant) return {};
    return Object.fromEntries(item.attributes.map(attribute => [attribute.name,
        variant.attributes[attribute.name] || preferred[attribute.name] || current[attribute.name]
        || item.defaults?.[attribute.name] || attribute.options[0]?.value || '',
    ]));
};
